export interface X9ContentStateStore {
  get<T>(key: string): T | null;

  set<T>(key: string, value: T): void;

  getContentState<T>(id: number): T | null;

  setContentState<T>(id: number, state: T): void;

  getScopedContentState<T>(id: number, scope: string | number): T | null;

  setScopedContentState<T>(id: number, scope: string | number, state: T): void;
}

export function contentKey(id: number): string {
  return 'content-' + id;
}

export function scopedContentKey(id: number, scope: string | number): string {
  return 'content-' + id + '/' + scope;
}
